
 
 // Truncate Product Description

$(document).ready(function() {
  (function() {
    var showChar = 50;
    var ellipsestext = "...";

    $(".truncate").each(function() {
      var content = $(this).html();
      if (content.length > showChar) {
        var c = content.substr(0, showChar);
        var h = content;
        var html =
          '<div class="truncate-text" style="display:block">' +
          c +
          '<span class="moreellipses">' +
          ellipsestext +
          '&nbsp;&nbsp;<a href="" class="moreless more">more</a></span></span></div><div class="truncate-text" style="display:none">' +
          h +
          '<a href="" class="moreless less">Less</a></span></div>';

        $(this).html(html);
      }
    });

    $(".moreless").click(function() {
      var thisEl = $(this);
      var cT = thisEl.closest(".truncate-text");
      var tX = ".truncate-text";

      if (thisEl.hasClass("less")) {
        cT.prev(tX).toggle();
        cT.slideToggle();
      } else {
        cT.toggle();
        cT.next(tX).fadeToggle();
      }
      return false;
    });
    /* end iffe */
  })();

  /* end ready */
});


// Cart Samples


function displayCartRecommendations() {
jQuery.getJSON(window.Shopify.routes.root + 'cart.js', (cart) =>  {
    const cartProductIds = [];
    const relatedProducts = [];
    const products = [1502369382500, 7951505752307, 7951505752307, 8005440340211, 8006413123827, 5713534320806, 4686540406884, 1502414143588, 7833188860147, 1502513299556]
    
    // Loop through cart items
    for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];
      
        // Set product Vars
        var oil = 1502369382500;
        var cava = 7951505752307;
        var facem = 8005440340211;
        var facew = 8006413123827;
        var derma5 = 5713534320806;
        var duo = 4686540406884;
        var serum = 1502414143588;
        var derma2 = 7833188860147;
        var kit = 1502513299556;
      
        // Store product ID in cartProductIds array
        cartProductIds.push(item.product_id);     
      
        // Push Oil (1502369382500) related product IDs in relatedProducts array
        if (item.product_id === oil){ 
          relatedProducts.push(cava);
        }
        // Push Face Oils (her = 8006413123827, him = 8005440340211) related product IDs in relatedProducts array
        if (item.product_id === facew){
          relatedProducts.push(derma5);
        }
        if (item.product_id === facem){
          relatedProducts.push(derma5);
        }
        // Push Duo (4686540406884) related product IDs in relatedProducts array
        if (item.product_id === duo){
          relatedProducts.push(derma5);
        }
        // Push Serum (4686540406884) related product IDs in relatedProducts array
        if (item.product_id === serum){
          relatedProducts.push(oil);
        }
        // Push Cava (7951505752307) related product IDs in relatedProducts array
        if (item.product_id === cava){
          relatedProducts.push(oil);
        }
        // Push Kit (1502513299556) related product IDs in relatedProducts array
        if (item.product_id === kit){
          relatedProducts.push(cava);
        }
        // Push Rollers(5713534320806) related product IDs in relatedProducts array
        if (item.product_id === derma5){
          relatedProducts.push(facew, facem, oil);
        }
        if (item.product_id === derma2){
          relatedProducts.push(facew, facem, oil);
        }
      
    }
    var displayProdRec = relatedProducts.filter(function(obj) { 
      return cartProductIds.indexOf(obj) == -1; 
    });
  
    const upSellsMainEl = document.getElementById('upSells');
  
    if (displayProdRec.length === 0 ) {
        upSellsMainEl.style.display = 'none';
      } else {
        upSellsMainEl.style.display = 'block';
    }

    // Get a reference to the master div
    const masterDiv = document.getElementById("cartUpSells");

    // Hide all div elements with data-product-id attributes initially
    const allDivEl = masterDiv.querySelectorAll('[data-product-id]');
    allDivEl.forEach(divEl => {
      divEl.style.display = "none";
    });
  
    // Loop through the array of unique IDs
    displayProdRec.forEach(prodID => {
      // Find the corresponding div element within the master div by its ID
      const divElement = masterDiv.querySelector(`[data-product-id="${prodID}"]`);
    
      // Check if the div element exists
      if (divElement) {
        // If it exists, display the div element
        divElement.style.display = "block"; // You can use any display property you prefer
      } else {
        divElement.style.display = "none";
      }
    });
});

}

document.addEventListener('cart:updated', displayRecommendations);
document.addEventListener('ajaxProduct:added', displayRecommendations);
document.getElementById('HeaderCartTrigger').addEventListener("click", displayRecommendations);

//  document.addEventListener('page:loaded', function() {
//  displayRecommendations();
//  });

function displayRecommendations() {
displayCartRecommendations();
//  document.dispatchEvent(new CustomEvent('cart:build'));
}


$("#custom-collection-filter").children("h4").click(function(){
$(this).toggleClass("open");
$(this).next("ul").slideToggle();
});

